import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const SoReportPageRBAC = {
  pageID: '0fe6efb0c9d7105a93a81f6404789116',
  elementID: {
    BtnClearRemarks: 'ce8c4e28a4f7b78d96cf37d63517b534',
    BtnDownloadCsv: 'e6b75989c843ea2a59abf9dc39e33d32',
    BtnDownloadItem: 'bfd4f65c1a91221c569c71fb30902d3f',
  },
} as const

export const useRBACSoReportPage = createUseRBAC(SoReportPageRBAC.elementID)

export type UseRBACSoReportPageType = ReturnType<typeof useRBACSoReportPage>
